// extracted by mini-css-extract-plugin
export var cardIcon = "_4g-4";
export var checkboxCard = "_4g-0";
export var checkboxCardSelected = "_4g-1";
export var disabled = "_4g-2";
export var outerBorder = "_4g-3";
export var spacerMedium = "_4g-7";
export var spacerSmall = "_4g-6";
export var spacerXsmall = "_4g-5";